import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

const RegularMenuWrapper = styled.ul`
  &.regular__menu {
    display: flex;
    align-items: center;
    justify-content: center;
    
    li {
      margin: 0 8px;
      
      a {
        color: ${themeGet('colors.black', '#000')};
        font-size: 15px;
        line-height: 2.5;
        padding: 5px;
        transition: 0.15s ease-in-out;
        
        &:hover {
          color: ${themeGet('colors.primary', '#1089ff')};
        }
      }
    }
  }
`;

export default RegularMenuWrapper; 